export enum SystemConfigurationValueType {
    "EnableAccountNumber" = 21,
    "EnablePhoneNumber" = 23,
    "EnableEmailAddress" = 24,
    "EnableCustomField" = 27,
    "EnableDateOfBirth" = 26
}